import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { FirebaseService } from '../services/firebase.service';

import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { environment } from '../../environments/environment.development';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './loginpage.component.html',
  styleUrl: './loginpage.component.css',
})




export class LoginpageComponent implements OnInit, AfterViewInit {

  @Output() tokenValidated = new EventEmitter<string>()


  constructor(private firebaseService: FirebaseService, private router: Router, private http: HttpClient) { }
  ngOnInit(): void {
    onAuthStateChanged(getAuth(), user => {
      if (user) {
        this.router.navigate(['admin'])
      }
    })
  }
  ngAfterViewInit(): void {





  }

  private siteKey = environment.TURNSTILE_SITE_KEY




  sendingData = false
  showError = false
  email = '';
  password = '';
  errorMessage = ''


  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
    ]),
  });

  isLoginMode = true;

  toggleMode() {
    this.isLoginMode = !this.isLoginMode;
    this.showError = false;
    this.errorMessage = '';
    this.loginForm.reset();
  }

  async initiateLogin() {
    if (this.loginForm.invalid) {
      return;
    }

    this.sendingData = true;
    this.showError = false;

    const email = this.loginForm.value.email!.trim();
    const password = this.loginForm.value.password!.trim();

    try {
      if (this.isLoginMode) {
        console.log('Trying to log in');
        await this.firebaseService.logIn(email, password);
      } else {
        console.log('Trying to sign up');
        await this.firebaseService.signUp(email, password);
      }
      this.router.navigate(['/admin']);
    } catch (e: any) {
      this.sendingData = false;
      this.showError = true;
      console.error(e);

      if (e.code === 'auth/invalid-credential' || e.code === 'auth/wrong-password' || e.code === 'auth/user-not-found') {
        this.errorMessage = 'Email or password is incorrect.';
      } else if (e.code === 'auth/email-already-in-use') {
        this.errorMessage = 'This email is already registered.';
      } else if (e.code === 'auth/invalid-email') {
        this.errorMessage = 'The provided email is invalid.';
      } else if (e.code === 'auth/too-many-requests') {
        this.errorMessage = 'Too many attempts. Please try again later.';
      } else if (e.code === 'auth/weak-password') {
        this.errorMessage = 'Password should be at least 6 characters.';
      } else {
        this.errorMessage = 'Something went wrong. Please try again.';
      }
    }
  }
}
